import { useEffect, useState } from 'react';
import { getRoleAccessTypes, RoleAccessTypeItem } from '../../../../../api/ticketApi';

export type SupportTierRoleOption = {
  roleId: number;
  roleName: string;
};

/**
 * Support-tier Role options for the Access Type Tier dropdown's "Support" branch.
 * `screenContext` controls whether User-Management-only roles (Super User, Developer,
 * External Equipment Vendor) are included — excluded on the self-service Access Request
 * form, included in the admin User Management screen.
 */
const useSupportTierRoles = (screenContext: 'user-management' | 'access-request') => {
  const [roles, setRoles] = useState<SupportTierRoleOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getRoleAccessTypes()
      .then((items: RoleAccessTypeItem[]) => {
        if (cancelled) return;
        const supportRoles = items
          .filter((item) => {
            let tiers: string[] = [];
            try {
              tiers = JSON.parse(item.accessTypeTiers || '[]');
            } catch {
              tiers = [];
            }
            if (!tiers.includes('Support')) return false;
            if (screenContext === 'access-request' && item.isUserManagementOnly) return false;
            return true;
          })
          .map((item) => ({ roleId: item.roleId, roleName: item.roleName }));
        setRoles(supportRoles);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [screenContext]);

  return { supportTierRoles: roles, supportTierRolesLoading: loading };
};

export default useSupportTierRoles;
